import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b418551c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b418551c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_babel-core@6.26.3_coffee-script@1.12.7_css-loader_7ao6wvor7ufxsioi5wi4wk5p4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b418551c",
  null
  
)

export default component.exports